import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {pick} from 'ramda';
import classNames from 'classnames';
import styles from './Button.scss';

const getClassNames = (displayType, href, className) =>
  classNames(styles.Button, className, {
    [styles.link]: !!href,
    [styles.primaryButton]: displayType === 'primary',
    [styles.secondaryButton]: displayType === 'secondary',
    [styles.whiteButton]: displayType === 'white',
    [styles.dashedButton]: displayType === 'dashed',
  });

const filterButtonProps = pick([
  'children',
  'id',
  'onClick',
  'onMouseDown',
  'onDblClick',
  'onMouseUp',
  'onMouseOver',
  'onMouseOut',
  'onKeyPress',
  'onKeyDown',
  'onKeyUp',
  'autoFocus',
  'disabled',
  'name',
  'type',
  'value',
]);

const filterAnchorProps = pick([
  'children',
  'id',
  'onClick',
  'onMouseDown',
  'onDblClick',
  'onMouseUp',
  'onMouseOver',
  'onMouseOut',
  'onKeyPress',
  'onKeyDown',
  'onKeyUp',
  'autoFocus',
  'disabled',
  'name',
  'href',
]);

class Button extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    displayType: PropTypes.oneOf(['default', 'primary', 'secondary', 'white', 'dashed']),
    href: PropTypes.string,
  }
  static defaultProps = {
    children: 'Button',
    className: undefined,
    displayType: 'default',
    href: undefined,
  };
  render(){
    const {className, displayType, href} = this.props;

    const btnClass = getClassNames(displayType, href, className);

    return href
      ? <a {...filterAnchorProps(this.props)} className={btnClass} />
      : <button type="button" {...filterButtonProps(this.props)} className={btnClass} />;
  }
}

export class FauxButton extends PureComponent{
  static propTypes = Button.propTypes;
  static defaultProps = Button.defaultProps;
  render(){
    const {className, displayType, children, ...rest} = this.props;
    return <div tabIndex="0" className={getClassNames(displayType, undefined, className)} {...rest}>{children}</div>;
  }
}

export default Button;
